import {
	Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges,
	SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { ConfigurationService } from 'configuration';
import { DeviceCategory } from 'DiscoveryEngine.TS/Core';


export class CategorySelectorEntry {
	public dataKey: string;
	public name: string;

	constructor() {
		this.dataKey = "";
		this.name = "";
	}
}


@Component({
	selector: 'device-category-selector',
	templateUrl: './device-category-selector.component.html',
	styleUrls: ['./device-category-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceCategorySelectorComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	public selection: string[];

	@Input()
	public scrollHeight: string;

	@Output()
	public selectionChange: EventEmitter<string[]>;

	public cols: any[];
	public tableEntries: CategorySelectorEntry[];
	public tableSelection: CategorySelectorEntry[];

	private categoryNames: string[] = [];

	constructor(private configService: ConfigurationService,	// This reference forces device categories to load
		private changeDetector: ChangeDetectorRef) {

		this.selection = [];
		this.selectionChange = new EventEmitter<string[]>();
		this.tableEntries = [];
		this.tableSelection = [];
		this.categoryNames = [];

		this.cols = [
			{ field: 'name', header: 'Category Name' },
		];

		this.buildCategoryNames();
		this.buildTableEntries();
		this.buildTableSelection();

		this.configService.onDeviceCategoriesLoaded.subscribe((result: boolean) => {
			this.buildCategoryNames();
			this.buildTableEntries();
			this.buildTableSelection();

			this.changeDetector.detectChanges();
		});
	}

	public doCustomSort(event): void {
		let comparer = function (a: CategorySelectorEntry, b: CategorySelectorEntry): number {
			let result = 0;

			switch (event.field) {
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		this.tableEntries.sort(comparer);
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["selection"];
		if (change) {
			this.buildTableSelection();
		}
	}

	public ngOnDestroy(): void {

	}

	private buildCategoryNames(): void {
		this.categoryNames = [];
		DeviceCategory.GetAll().ForEach((devCat: DeviceCategory) => {
			this.categoryNames.push(devCat.Name);
		});

		this.categoryNames.sort();
	}

	private buildTableEntries(): void {
		this.tableEntries = [];
		this.categoryNames.forEach((catName: string) => {
			let entry = new CategorySelectorEntry();

			entry.dataKey = catName;
			entry.name = catName;

			this.tableEntries.push(entry);
		}, this);
	}

	private buildTableSelection(): void {
		this.tableSelection = [];
		this.selection.forEach((selCat: string) => {
			let selEntry = this.findTableEntryByName(selCat);
			if (selEntry) {
				this.tableSelection.push(selEntry);
			}
		}, this);
	}

	private findTableEntryByName(name: string): CategorySelectorEntry {
		return this.tableEntries.find(entry => entry.name == name);
	}

	public get selectedCategoryCount(): number {
		if (this.tableSelection) {
			if (Array.isArray(this.tableSelection)) {
				return this.tableSelection.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}

	public updateSelection(): void {
		this.selection = [];
		this.tableSelection.forEach((entry: CategorySelectorEntry) => {
			this.selection.push(entry.name);
		}, this);
	}

	public onSelectionChange(event): void {
		this.updateSelection();
		this.selectionChange.emit(this.selection);
	}
}
